var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('van-nav-bar',{attrs:{"title":_vm.$store.state.pageTitle}}),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view',{staticClass:"router"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }